/**
 * Read ids / display strings from path lander/offer rows.
 * For Media Devoted | Created By Ciro Autiero
 */

import { getPathItemDisplay, type PathItemKind } from '../../../utils/path-item-display';

export function pathItemEntityNoun(kind: PathItemKind): 'lander' | 'offer' {
  return kind === 'landers' ? 'lander' : 'offer';
}

export function readPathItemDisplayName(
  row: unknown,
  kind: PathItemKind,
): string {
  if (!row || typeof row !== 'object') return '';
  const r = row as Record<string, unknown>;
  const v = kind === 'landers' ? r.landerName : r.offerName;
  return typeof v === 'string' ? v.trim() : '';
}

export function readPathItemEntityId(
  row: unknown,
  kind: PathItemKind,
): string {
  const { id } = getPathItemDisplay(row, kind);
  return id === '—' ? '' : id;
}
